import { Injectable } from '@angular/core';
import { BaseRequestOptions, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { DateUtils } from 'ng-jhipster';
import 'rxjs/add/operator/map';
import { isNull } from 'util';
import { UserBlob } from '../../shared';
import { LicenceSchool } from '../licence-school/licence-school.model';
import { PropositionStatus } from '../master-proposal/master-proposal.model';
import { Rejection } from '../rejection/rejection.model';
import { SaisineHistory } from '../saisine-history/saisine-history.model';
import { Mention } from './mention.model';
import { Saisine, SaisineStatus } from './saisine.model';

@Injectable()
export class SaisineService {

    private studentSaisineUrl = 'api/student-saisine';
    private mentionUrl = 'api/mentions';
    private licenceSchoolsUrl = 'api/licence-schools';

    private resourceInterneUrl = 'api/interne/saisines';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(saisine: Saisine): Observable<Saisine> {
        let copy: Saisine = Object.assign({}, saisine);
        copy.birthDate = this.dateUtils.convertLocalDateToServer(saisine.birthDate);
        return this.http.post(this.studentSaisineUrl, copy).map(this.fromJSON);
    }

    update(saisine: Saisine): Observable<Saisine> {
        let copy: Saisine = Object.assign({}, saisine);
        copy.birthDate = this.dateUtils.convertLocalDateToServer(saisine.birthDate);
        return this.http.put(this.studentSaisineUrl, copy).map(this.fromJSON);
    }

    abandon(saisine: Saisine): Observable<Saisine> {
        let copy: Saisine = Object.assign({}, saisine);
        copy.birthDate = this.dateUtils.convertLocalDateToServer(saisine.birthDate);
        return this.http.put(`${this.studentSaisineUrl}/${saisine.id}/abandoned`, copy).map(this.fromJSON);
    }

    find(id: number): Observable<Saisine> {
        return this.http.get(`${this.resourceInterneUrl}/${id}`).map(this.fromJSON);
    }
    findStudentSaisine(): Observable<Saisine> {
        return this.http.get(this.studentSaisineUrl).map(this.fromJSON);
    }

    addStudentSaisineComment(saisineComment): Observable<Response> {
        return this.http.post(`${this.studentSaisineUrl}/saisine-comment`, saisineComment);
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceInterneUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    getMentions(req?: any): Observable<Mention[]> {
        let options = this.createRequestOption(req);
        return this.http.get(this.mentionUrl, options)
            .map((res: Response) => {
                return res.json() as Mention[];
            });
    }

    getLicenceSchools(): Observable<LicenceSchool[]> {
        return this.http.get(this.licenceSchoolsUrl)
            .map((res: Response) => {
                return res.json() as LicenceSchool[];
            });
    }

    addSaisineComment(saisineId: number, saisineComment ): Observable<Response> {
        return this.http.post(`${this.resourceInterneUrl}/${saisineId}/saisine-comment`, saisineComment);
    }

    addRejection(saisineId: number, rejection ): Observable<Rejection> {
        let copy: Rejection = Object.assign( {}, rejection );
        return this.http.post(`${this.resourceInterneUrl}/${saisineId}/rejections`, copy).map(this.fromJSON);
    }

    addValidation(saisineId: number): Observable<Response> {
        return this.http.post(`${this.resourceInterneUrl}/${saisineId}/check`, null);
    }

    cancelRejection(saisineId: number): Observable<Response> {
        return this.http.post(`${this.resourceInterneUrl}/${saisineId}/cancel-rejection`, null);
    }

    cancelValidation(saisineId: number): Observable<Response> {
        return this.http.post(`${this.resourceInterneUrl}/${saisineId}/cancel-check`, null);
    }

    addMasterProposal(saisineId: number, masterProposal ): Observable<Saisine> {
        return this.http.post(`${this.resourceInterneUrl}/${saisineId}/master-proposal`, masterProposal).map(this.fromJSON);
    }

    getSaisineHistory(id: number): Observable<SaisineHistory[]> {
        return this.http.get(`${this.resourceInterneUrl}/${id}/saisine-history`).map((res: Response) => {
            return res.json() as SaisineHistory[];
        });
    }
    getSaisineDocumentsInfo(id: number): Observable<UserBlob[]> {
        return this.http.get(`${this.resourceInterneUrl}/${id}/documents`).map((res: Response) => {
            let userBlobs = res.json() as UserBlob[];
            userBlobs.forEach(d => d.creationDate = this.dateUtils.convertDateTimeFromServer(d.creationDate));
            return userBlobs;
        });
    }

    cancelSaisine(saisineId: number, rejection ): Observable<Saisine> {
        let copy: Rejection = Object.assign( {}, rejection );
        return this.http.put(`${this.resourceInterneUrl}/${saisineId}/cancel`, copy).map(this.fromJSON);
    }

    // bind to this
    fromJSON = (pJson: Response | any): Saisine => {
        let json = null;
        if (pJson instanceof  Response) {
            json = (pJson as Response).json();
        } else {
            // Regular JSON
            json = pJson;
        }
        let saisine: Saisine = Object.assign(new Saisine(), json);

        if (json.birthDate) {
            saisine.birthDate = new Date(json.birthDate);
        }

        saisine.creationDate = this.dateUtils.convertDateTimeFromServer(json.creationDate);
        saisine.lastModificationDate = this.dateUtils.convertDateTimeFromServer(json.lastModificationDate);
        saisine.submitDate = this.dateUtils.convertDateTimeFromServer(json.submitDate);
        saisine.firstSubmitDate = this.dateUtils.convertDateTimeFromServer(json.firstSubmitDate);
        saisine.checkingDate = this.dateUtils.convertDateTimeFromServer(json.checkingDate);
        saisine.closureDate = this.dateUtils.convertDateTimeFromServer(json.closureDate);
        saisine.abandonedDate = this.dateUtils.convertDateTimeFromServer(json.abandonedDate);

        saisine.numberStudentConfirmed = 0;
        saisine.numberStudentProposals = 0;
        saisine.numberStudentRefused = 0;

        if (!saisine.refusedMasters) {
            saisine.refusedMasters = [];
        }

        if (!saisine.masterProposals) {
            saisine.masterProposals = [];
        } else {
            for (let i = 0; i < saisine.masterProposals.length; i++) {
                if (saisine.masterProposals[i].master) {
                    saisine.masterProposals[i].formationLabel = saisine.masterProposals[i].master.masterLabel;
                    if (saisine.masterProposals[i].master.specialityLabel) {
                        saisine.masterProposals[i].formationLabel += ' - ' + saisine.masterProposals[i].master.specialityLabel;
                    }

                    if (isNull(saisine.masterProposals[i].master.residualVacantPlaces)) {
                        saisine.masterProposals[i].master.residualVacantPlacesDisplayed = 'Non renseignées';
                        saisine.masterProposals[i].master.availablePlacesDisplayed = '';
                    } else {
                        saisine.masterProposals[i].master.residualVacantPlacesDisplayed = saisine.masterProposals[i].master.residualVacantPlaces + ' ';
                        saisine.masterProposals[i].master.availablePlaces = saisine.masterProposals[i].master.residualVacantPlaces - saisine.masterProposals[i].master.attributedPlaces;
                        saisine.masterProposals[i].master.availablePlacesDisplayed =  saisine.masterProposals[i].master.availablePlaces + ' ';
                    }
                }

                if (saisine.masterProposals[i].status != null) {
                    saisine.masterProposals[i].status = PropositionStatus[saisine.masterProposals[i].status + ''];
                }

                // S'il n'y a qu'une date de reponse de l'etablissement et pas de date de proposition a l'etablissement alors la proposition de master
                // A été proposée par l'etablissement ==> pour certain tableaux mise en couleur via le flag isSuggestedBySchool
                (saisine.masterProposals[i].schoolResponseDate && !saisine.masterProposals[i].schoolProposalDate) ? saisine.masterProposals[i].isSuggestedBySchool = true : saisine.masterProposals[i].isSuggestedBySchool = false;
            }
        }
        if (!saisine.rejections) {
            saisine.rejections = [];
        } else {
            saisine.rejections = saisine.rejections.map(r => {
               return new Rejection(r.id, this.dateUtils.convertDateTimeFromServer(r.date), r.label);
            });
        }

        if (saisine.status == null) {
            saisine.status = SaisineStatus.IN_PROGRESS;
        } else {
            saisine.status = SaisineStatus[saisine.status + ''];
        }

        if (saisine.reportCards) {
            saisine.reportCards.sort(function(a, b) {return a.id - b.id; } );
        }

        return saisine;
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i] = this.fromJSON(jsonResponse[i]);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            params.set('campaign', req.campaign);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine.service.ts